export class FileUploadValidator {
    /**
     * Basic custom file upload validator
     * called before user uploads a file into the backend
     * @param {Object} files - The file object that contain the uploaded file details such as name, type, size, etc.
     * @param {string} key = The upload component key constant set manually on the <UploadFile> component props
     * On initialize (new FileUploadValidator({ ... }), the validator starts validating several parameters defined in
     * the function below
     * 1. Correct file type
     * 2. Correct extension
     * 3. Correct file size
     */
    constructor({ files, key }) {
        // data initialization
        this.files = files;
        this.key = key;
        this.type = files[0].type;
        this.size = files[0].size;
        this.valid = true;
        this.messages = [];
        this.accepted_pdf_files = {
            ro_employment_contract_document: "kontrak pekerja",
            employment_contract_document: "kontrak pekerja",
            coe: "coe",
            ro_membership_application_document: "dokumen permohonan keanggotaan",
            selfie_contract_document: "dokumen permohonan keanggotaan",
        };

        // conditionals initialization
        this.isIDorIDSelfie =
            this.key == "ktp" ||
            this.key == "selfie_ktp" ||
            this.key == "ro_ktp" ||
            this.key == "ro_selfie_ktp";
        this.isAnImage = this.type.includes("image/");
        this.isParentalForm = this.key === "parental_consent_form"


        // validation initiated
        this.validateFileType();
        this.validateExtension();
        this.validateFileSize();
    }

    /**
     * for KTP and KTP selfie, the file has to be an image.
     * And for employment contract, CoE, and selfie contract document, the file has to be in PDF
     */
    validateFileType = () => {
        if (this.isIDorIDSelfie && !this.isAnImage) {
            this.valid = false;
            this.messages.push("Dokumen yang diunggah harus format image!");
        }

        if (
            Object.keys(this.accepted_pdf_files).includes(this.key) &&
            this.type !== "application/pdf"
        ) {
            this.valid = false;
            this.messages.push("Dokumen yang diunggah harus format PDF!");
        }
    };

    /**
     * for KTP and KTP selfie, it has to be a JPEG format,
     * for employment contract, PDF format,
     * the rests of the files accepts JPG, JPEG, PNG, GIF, BMP, and PNG
     */
    validateExtension = () => {
        const splitFile = this.type.split("/");
        const ACCEPTED_PDF_FILES = this.accepted_pdf_files;

        let check;
        let message;

        switch (this.key) {
            case "ktp":
            case "ro_ktp":
            case "ro_selfie_ktp":
            case "selfie_ktp":
                check = /(jpe?g|jpg)$/i.test(splitFile[1]);
                message = "format ktp dan selfie ktp harus dalam format JPEG atau JPG";
                break;
            case "ro_employment_contract_document":
            case "ro_membership_application_document":
            case "employment_contract_document":
                check = /(pdf)$/i.test(splitFile[1]);
                message = `format ${ACCEPTED_PDF_FILES[this.key]} harus dalam format PDF`;
                break;
            case "parental_consent_form":
                check = /(pdf|png|jpg|jpeg)$/i.test(splitFile[1]);
                message = `format dokumen pernyataan harus dalam format PDF/JPG/PNG`;
                break;
            case "collateral_document":
                check = /(pdf|png|jpg|jpeg)$/i.test(splitFile[1]);
                message = `format dokumen agunan harus dalam format PDF/JPG/PNG`;
                break;
            default:
                check = /(jpe?g|jpg|png|gif|bmp|pdf)$/i.test(splitFile[1]);
                message = "format file tidak valid";
        }

        if (!check) {
            this.valid = false;
            this.messages.push(message);
        }
    };

    /**
     * for KTP and selfie KTP, the size limit is 1 MB
     */
    validateFileSize = () => {
         if (this.isParentalForm) {
            const maxSize = 5 * 1024 * 1024; // 1 MB limit
            const fileSize = this.size;

            if (fileSize > maxSize) {
                this.valid = false;
                this.messages.push("Ukuran dokumen tidak boleh lebih dari 5MB!");
            }
        }
    };
}
